// resources/js/components/Header.js

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import '/css/app.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import p_quality from '/images/Quality_Picture_cut_v01.webp';

export default function Footer() {
    return (
        <div className="row d-flex justify-content-center bg-verylightgray">
            <div className="col-md-9 d-flex justify-content-center align-items-center mb-1 mt-1 fs-7 fw-bold">
                <div className="col-6 d-flex justify-content-center flex-column">
                    <a href="https://www.linkedin.com/company/the-low-price-display-experts" target="_blank" className="text-decoration-none text-reset">
                        <div className="d-flex">
                        {/* <FontAwesomeIcon icon="fa-brands fa-linkedin" /> */}
                            <div className="me-1">LinkedIn</div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="linkedin-icon"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>
                            
                        </div>
                    </a>
                    <div><Link to="/about" className='text-decoration-none text-reset'>About us</Link></div>
                    <div><Link to="/contact" className='text-decoration-none text-reset'>Contact</Link></div>
                </div>
                <div className="col-6 ">
                    <Link to="/quality" className='text-decoration-none text-reset d-flex justify-content-center btn border-secondary btn-light'>
                        {/* <div className=''> */}
                            <div className="align-self-center fs-7 fw-bold schum-color">
                                <div>Quality Controlled by Germany</div>
                            </div>
                        {/* </div> */}
                        {/* <div className=''> */}
                            <div className="align-self-center">
                                <img src={p_quality} className="icon_quality w-100" alt="Quality"/>
                            </div>
                        {/* </div> */}
                    </Link>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('footer')) {
    const container = document.getElementById('footer');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<Footer />);
}